import React from "react";
import { ProductManager } from "@/components/catalog/ProductManager";

export default function AdminProducts() {
  return <ProductManager isAdmin />;
}
